import Vue from 'vue';

function PaymentMethod(config) {
	if (!(this instanceof PaymentMethod)) {
		return new PaymentMethod(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

PaymentMethod.prototype = {
	constructor: PaymentMethod,

	id: '',
	last4: '',
	brand: '',
	expiry: null,
	primary: false,

	toString: function () {
		return '[PaymentMethod:' + (this.id || this.last4) + ']';
	},

	toJSON: function () {
		return PaymentMethod.toDTO(this);
	}
};

function getCardType(brand) {
	brand = (brand + '').toLowerCase();
	switch (brand) {
	case 'american express': return 'amex';
	case 'diners club': return 'diners';
	case 'unknown': return '';
	default: return brand;
	}
}

PaymentMethod.fromToken = function (token) {
	if (token === null || token === undefined) {
		return null;
	}
	var card = token && token.card || {};
	return token && token.object === 'token' ? new PaymentMethod({
		id: card.id,
		token: token.id,
		primary: true,
		last4: card.last4,
		brand: getCardType(card.brand),
		expiry: new Date(
			card.exp_year,
			Math.max(0, card.exp_month - 1)
		)
	}) : null;
};

PaymentMethod.fromDTO = function (dto) {
	if (dto === null || dto === undefined) {
		return null;
	}
	const expiry = new Date(dto.expirationYear, dto.expirationMonth),
		now = new Date();

	return new PaymentMethod({
		id: dto.id,
		token: null,
		primary: dto.isDefault,
		last4: dto.last4,
		brand: getCardType(dto.brand),
		expiry: expiry,
		expired: expiry < now
	});
};

PaymentMethod.toDTO = function (method) {
	var expiry = method && method.expiry;
	return method && {
		id: method.id,
		isDefault: (method.primary === true),
		last4: method.last4,
		brand: method.brand,
		expirationYear: expiry && expiry.getFullYear(),
		expirationMonth: expiry && expiry.getMonth() + 1
	};
};

export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/store/models/payment-method.js